export default __webpack_public_path__ + "94a459f7c2e336fa004351a87c5b0981.svg";